import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '../store/index.js';
import materialMarketRoutes from './material-market';
import {getUrlParam} from '@/util/util'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

NProgress.configure({ showSpinner: false });

// import Layout from '@/views/layout/Layout';

/**
 * 不需要权限的基础页面
 * 所有角色能够访问
 */
export const constantRoutes = [
    // {
    //     path: '/',
    //     component: Layout,
    //     redirect: '/material-market',
    //     children: []
    // },
    materialMarketRoutes,
    {
        path: '/404',
        component: () => import('@/views/error-page/404')
    },
    {
        path: '/401',
        component: () => import('@/views/error-page/401')
    },
    // 404 页放在最后
    {
        path: '*',
        redirect: '/404'
    }
];

/**
 * 异步路由
 * 根据用户角色动态加载的路由
 */
export const asyncRoutes = [
    {
        path: '*',
        redirect: '/404'
    }
];

const createRouter = () =>
    new Router({
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

// 导航守卫
router.beforeEach((to, from, next) => {
    // 显示页面顶部进度条
    if (to.meta.showPageProgress) {
        NProgress.start();
        to.meta.showPageProgress = !to.meta.showPageProgress;
    }

    // 调整页面 title

    document.title = to.meta.title ? to.meta.title : window.Config.projectName;
    if(from.path === '/'){
        let platform = getUrlParam('platform');
        if(platform){
            to.query.platform = platform;
        }
    }
    store.dispatch('getUserInfo').then(() => {
        next();
    });
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
